import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../ampli';
import { Icon } from '../../../components/common/icon/Icon';
import { useLayout } from '../../../hooks/screen/useLayout';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useLayout({
    fixedHeader: <></>,
    fixedFooter: <></>,
    fixedFooterHeight: 0,
    fixedHeaderHeight: 0,
  });

  useEffect(() => {
    const goToHome = setTimeout(() => {
      navigate('/home');
    }, 3000);

    return () => clearTimeout(goToHome);
  }, [navigate]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    ampli.기타낫파운드페이지조회({
      '접속 시도한 페이지 URL': urlParams.has('from') ? urlParams.get('from')! : '',
    });
  }, [location]);

  return (
    <Container>
      <Icon name={'EmptyBox2'} width={160} height={160} />
      <TextSection>
        <Title>{'앗! 죄송합니다'}</Title>
        <Content>{'찾고 계신 페이지가 없어요.\n3초후 홈으로 이동합니다 :)'}</Content>
      </TextSection>
      <GotoHomeButton to={'/home'}>
        <ButtonText>{'홈으로'}</ButtonText>
      </GotoHomeButton>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 32px;
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 4px;
`;

const Title = styled.h2`
  color: var(--light-scheme-monochrome-black, #232429);
  /* System/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 15.3px */
`;

const Content = styled.pre`
  color: var(--light-scheme-monochrome-offblack, #505363);
  text-align: center;
  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

const GotoHomeButton = styled(Link)`
  display: flex;
  width: 167px;
  max-height: 40px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--light-scheme-color-primary-blue, #196eff);
`;

const ButtonText = styled.span`
  color: var(--light-scheme-monochrome-white, #fff);
  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
